/* ============================================================
   BASICARE — ストアヒーローのスライド

   カンプ index.html のインラインJSを移植したものです。動作はそのまま：
   動画（1回再生）⇄ 静止画 のクロスフェード。

   動画は残り時間を見てフェードを先行開始し、フェードが完全に終わるまで
   再生を続けます（終端で静止してから切り替わる「ピタ止まり」を防ぐため）。
   動きを抑える設定では自動再生・切替をせず、動画の先頭フレーム（poster）で静止します。

   Shopify 対応として、テーマエディタでセクションが差し替わったときに
   タイマーが二重に走らないよう初期化をやり直せる形にしています。
   ============================================================ */
(function () {
  var running = [];

  function stopAll() {
    running.forEach(function (stop) {
      stop();
    });
    running = [];
  }

  function initHero(bg) {
    var slides = bg.querySelectorAll('.sh-slide');
    if (slides.length < 2) return;

    var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce) return;

    var i = 0;
    var timer = null;
    var FADE_MS = 2400;
    var FADE_LEAD = 2.6;
    var STILL_MS = 16000;
    var VIDEO_MAX_MS = 16000;
    var disposed = false;

    function isVideo(el) {
      return el.tagName === 'VIDEO';
    }
    function clear() {
      clearTimeout(timer);
      timer = null;
    }

    function watch(v) {
      /* 残り FADE_LEAD 秒でフェード開始。フェード(2.4s)より少し早めなので、
         切り替え完了時点でもまだ動画が動いている */
      function onTime() {
        if (v.duration && v.duration - v.currentTime <= FADE_LEAD) {
          unwatch();
          go(i + 1);
        }
      }
      function onEnd() {
        unwatch();
        go(i + 1);
      }
      function unwatch() {
        v.removeEventListener('timeupdate', onTime);
        v.removeEventListener('ended', onEnd);
      }
      v.addEventListener('timeupdate', onTime);
      v.addEventListener('ended', onEnd);
      clear();
      /* 再生が始まらない場合の保険 */
      timer = setTimeout(function () {
        unwatch();
        go(i + 1);
      }, VIDEO_MAX_MS);
    }

    function go(n) {
      if (disposed) return;
      var prev = slides[i];
      prev.classList.remove('is-active');
      i = ((n % slides.length) + slides.length) % slides.length;
      var cur = slides[i];
      cur.classList.add('is-active');

      if (isVideo(prev) && prev !== cur) {
        /* 完全に隠れてから停止 */
        setTimeout(function () {
          try {
            prev.pause();
          } catch (e) {}
        }, FADE_MS + 100);
      }

      if (isVideo(cur)) {
        try {
          cur.currentTime = 0;
          var p = cur.play();
          if (p && p.catch) p.catch(function () {});
        } catch (e) {}
        watch(cur);
      } else {
        clear();
        timer = setTimeout(function () {
          go(i + 1);
        }, STILL_MS);
      }
    }

    if (isVideo(slides[0])) {
      try {
        var p0 = slides[0].play();
        if (p0 && p0.catch) p0.catch(function () {});
      } catch (e) {}
      watch(slides[0]);
    } else {
      timer = setTimeout(function () {
        go(i + 1);
      }, STILL_MS);
    }

    running.push(function () {
      disposed = true;
      clear();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.store-hero .bg').forEach(initHero);
  }

  init(document);

  document.addEventListener('shopify:section:load', function (e) {
    stopAll();
    init(e.target);
  });
  document.addEventListener('shopify:section:unload', stopAll);
})();
